import { createFileRoute } from "@tanstack/react-router";
import AdminPhase0Milestones from "@/pages/AdminPhase0Milestones";

export const Route = createFileRoute("/admin/phase0-milestones/")({
  component: AdminPhase0Milestones,
});
